import React from 'react'

import { BenefitsExtensionBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/benefitsExtensionBanner/BenefitsExtensionBanner'

import RacialStressBanner from '../../features/microsite/components/Banners/RacialStressBanner'

type BannerConfig = {
  component: React.ComponentType<$TSFixMe>
  paths: string[]
}

export const BANNERS: Record<string, BannerConfig> = {
  RACE: {
    component: RacialStressBanner as $TSFixMe,
    paths: ['/secure/index/search-care', '/secure/onboard'],
  },
  BENEFITS_EXTENSION: {
    component: BenefitsExtensionBanner,
    paths: [],
  },
}
